import { render, staticRenderFns } from "./options.vue?vue&type=template&id=620dd7b6&scoped=true&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"
import style0 from "./options.vue?vue&type=style&index=0&id=620dd7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dd7b6",
  null
  
)

export default component.exports